import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'sweetalert2';
import Swal from 'sweetalert2';
export default Swal;
